import React from 'react';
import { Card, CardBody } from 'reactstrap'; 

const AmountCard = ({ amount, icon, title , inrIcon }) => {
  const isNumber = !isNaN(parseFloat(amount));
  const formattedAmount = isNumber ? parseFloat(amount).toLocaleString('en-IN') : amount;
  const amountStyle = isNumber 
    ? "text-dark m-0 mb-2" 
    : "fs-sm fw-regular text-muted";

  return (
    <Card className='card-height-100'>
      <CardBody className="d-flex align-items-center ">
      {icon &&
        
        <div className=" d-flex align-items-center justify-content-start pe-3">
          <img src={icon} alt="investment" />
         {/* {icon} */}
        </div>
        }
        <div className="">
         
         {isNumber ? (
            <h3 className={amountStyle}
            style={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              overflowWrap: "anywhere",
            }}
            
            >{inrIcon && <><span className='text-muted me-2'>₹</span></>}{formattedAmount}</h3>
          ) : (
            <span className={amountStyle}>{formattedAmount}</span>
          )}
           <p className="fs-12 text-muted fw-semibold mb-1"
           style={{
            letterSpacing:"1px",
           }}
           >{title}</p>
        </div>
        
      </CardBody>
    </Card>
  );
};

export default AmountCard;



